import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
}                     from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  Alert,
  AlertTitle,
} from '@material-ui/lab';

import {
  stopResource as stopCrawl,
}                     from  '../../resource/hooks';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function DatasetActionStopCrawl(props) {
  const { dataset, open, onClose } = props;

  const [stopCrawlStatus, setStopCrawlStatus] = React.useState(null);
  const [stopCrawlMessage, setStopCrawlMessage] = React.useState(null);

  const classes = useStyles();


  const handleClose = () => {
    setStopCrawlStatus(null);
    setStopCrawlMessage(null);
    if(onClose) {
      onClose();
    }
  };

  const handleStopCrawl = async () => {
    setStopCrawlStatus('STOPPING');
    doStopCrawl(dataset.ResourceId);
  };
  
  const doStopCrawl = async (datasetId) => {
    const { succeeded, error } = await stopCrawl(datasetId);
    if(succeeded) {
      setStopCrawlStatus('STOPPED');
    } else {
      setStopCrawlStatus('FAILED');
      setStopCrawlMessage(error);
    }
  };
  
  return(
    <Dialog
      className={classes.root}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {stopCrawlStatus==='STOPPING'?
      <Alert severity="info">
        <AlertTitle>Stopping</AlertTitle>
        Stop crawl requested... <strong>please wait!</strong>
      </Alert>
      :stopCrawlStatus==='STOPPED'?
      <Alert severity="success" onClose={onClose}>
        <AlertTitle>Success</AlertTitle>
        Crawl stop requested successfully...  crawler may take a few minutes to stop
      </Alert>
      :stopCrawlStatus==='FAILED'?
      <Alert severity="error" onClose={onClose}>
        <AlertTitle>Error</AlertTitle>
        An error occurred requesting crawl stop: {stopCrawlMessage}
      </Alert>
      :
      <React.Fragment>
        <DialogTitle id="alert-dialog-title">
          Stop Crawl?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="prompt">
            Are you sure you want to stop the current crawl?
          </DialogContentText>
          <Alert severity="warning">
            Stopping will interrupt the current crawl which could result in inconsistent schema or missing partitions.
            
          </Alert>
          <DialogContentText>
            This will only affect the current crawl and may take a few minutes for crawler to come to a stop.  Automatic crawls will be initiated as needed after cooldown expires.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleStopCrawl} color="primary" autoFocus>
            Stop
          </Button>
        </DialogActions>
      </React.Fragment>
      }
    </Dialog>
  );
}

DatasetActionStopCrawl.propTypes = {
  dataset: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

DatasetActionStopCrawl.defaultProps = {
  open: true,
};